import { useMemo } from "react";

import { Lab } from "components/icons/generated";
import { MainNavigationItem, MainNavigationMenuItem } from "components/MainNavigation/types";

const useTryNewFeatures = (): MainNavigationItem | undefined => {
  return useMemo(() => {
    const items: MainNavigationMenuItem[] = [];

    if (items.length === 0) return undefined;

    return {
      id: "try-new-features",
      title: "Try New Features",
      icon: Lab,
      items: [{ items }],
    };
  }, []);
};

export default useTryNewFeatures;
